import { render, staticRenderFns } from "./DispatchersCard.vue?vue&type=template&id=d873ffae&scoped=true&"
import script from "./DispatchersCard.vue?vue&type=script&lang=js&"
export * from "./DispatchersCard.vue?vue&type=script&lang=js&"
import style0 from "./DispatchersCard.vue?vue&type=style&index=0&id=d873ffae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d873ffae",
  null
  
)

export default component.exports